/** COPPA / App Store age-assurance: children under this age cannot use the app. */
export const COPPA_MIN_AGE = 13;

/** Parse YYYY-MM-DD as a local calendar date (avoids UTC midnight off-by-one). */
export function parseIsoDateLocal(iso: string | null | undefined): Date | null {
    if (!iso) return null;
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso.trim());
    if (!match) return null;
    const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    if (
        isNaN(date.getTime()) ||
        date.getFullYear() !== Number(match[1]) ||
        date.getMonth() !== Number(match[2]) - 1 ||
        date.getDate() !== Number(match[3])
    ) {
        return null;
    }
    return date;
}

export function ageFromBirthdate(
    birthdate: string | null | undefined,
    today: Date = new Date()
): number | null {
    const date = parseIsoDateLocal(birthdate);
    if (!date) return null;

    let age = today.getFullYear() - date.getFullYear();
    const monthDiff = today.getMonth() - date.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < date.getDate())) {
        age -= 1;
    }
    return age;
}

/** True when a birthdate is present and the person is younger than 13. */
export function isUnder13(
    birthdate: string | null | undefined,
    today: Date = new Date()
): boolean {
    const age = ageFromBirthdate(birthdate, today);
    return age !== null && age < COPPA_MIN_AGE;
}
